export default __webpack_public_path__ + "static/media/dgm02-oea-best-practices-data-gov-400760(2011).d80a4d72.pdf";